import React from 'react';
import { LoadingArrow } from './LoadingArrow';
import { LoadingSpinner } from './LoadingSpinner';
export const LoadingIndicator = ({ variant, ...props }) => {
    switch (variant) {
        case 'arrow':
            return <LoadingArrow {...props}/>;
        default:
            return <LoadingSpinner {...props}/>;
    }
};
